import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { accountAtom } from "shared/lib/account";

import {
  MyDailyFiveArticleIdsStorageKey,
  MyDailyFiveLastUpdateTimeStorageKey,
  MyDailyFiveRecommendIdStorageKey,
} from "scmp-app/components/home/my-news-daily-five/consts";

export const useLocalStorageCleanUp = () => {
  const { isLoggedIn } = useAtomValue(accountAtom);

  useEffect(() => {
    if (isLoggedIn) {
      return;
    }
    // clean up local storage when logging out
    // my news local storage values
    localStorage.removeItem(MyDailyFiveArticleIdsStorageKey);
    localStorage.removeItem(MyDailyFiveLastUpdateTimeStorageKey);
    localStorage.removeItem(MyDailyFiveRecommendIdStorageKey);
  }, [isLoggedIn]);
};
